import React, { useEffect, useState } from "react";

import Game from "../../../class/Game/Game";
import Games from "../../../class/Game_copy/Game";

import AuthService from "../../../class/services/AuthService";
import NoResult from "./casino/noresult.js";

const SportContent = ({ isLogged, selection, lang, casinoSections }) => {
    const baseUrl = "https://vegas4fun.xframe.live";
    const [url, setUrl] = useState("https://vegas4fun.xframe.live/sport");
    const [iframeHeight, setIframeHeight] = useState(window.innerHeight);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let urlIframe = "";
                // console.log(AuthService.getCustom("user_id"));
                if (AuthService.getCustom("user_id") == undefined) {
                    const currency = AuthService.getCustom("currency");
                    const section =
                        typeof selection !== "undefined" && selection === "live"
                            ? "live"
                            : "sport";
                    urlIframe = `https://vegas4fun.xframe.live/${section}/${lang}`;
                    // urlIframe = `https://amatic365${currency}.xframe.live/${section}/${lang}`;
                } else {
                    const auth = await Games.authSport(
                        AuthService.getCustom("currency"),
                        lang,
                        selection,
                        AuthService.getCustom("user_id"),
                        true,
                    );

                    // console.log("auth:", auth);

                    if (auth["status"] == "ok") {
                        urlIframe = auth["params"]["url"];
                    }
                }
                setUrl(urlIframe);

                // setUrl(auth.url);

                const updateIframeHeight = () => {
                    const vh = window.innerHeight * 0.01;
                    document.documentElement.style.setProperty(
                        "--vh-sport",
                        `${vh}px`,
                    );
                    setIframeHeight(window.innerHeight);
                };

                updateIframeHeight();

                window.addEventListener("resize", updateIframeHeight);

                return () => {
                    window.removeEventListener("resize", updateIframeHeight);
                };
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [lang, selection, isLogged]);

    return (
        <div className="sport-content">
            {!casinoSections["sport"] ? (
                <iframe
                    className="sport-iframe"
                    scrolling="no"
                    id="sport"
                    src={url}
                    title="Sport Iframe"
                ></iframe>
            ) : (
                <NoResult />
            )}
        </div>
    );
};

export default SportContent;
